import { type AllTableCriteria, CriteriaDimension, SortDirection } from '@openx/types/tableCriteria.ts';
import { TABLE_PAGE_SIZE } from '../../../config.ts';
import type { DefaultTableCriteria } from '../../../utils/useListCriteria.ts';
import type { DealListFilters } from './types.ts';

export type DealsListCriteria = AllTableCriteria<DealListFilters>;

export const dealsDefaultCriteria: DefaultTableCriteria<'deals'> = {
  [CriteriaDimension.SORT]: {
    column: 'modified_date',
    direction: SortDirection.DESC,
    sortableColumns: [
      'name',
      'status',
      'health_score',
      'deal_price',
      'spend',
      'partner_revenue',
      'impressions',
      'cpm',
      'start_date',
      'end_date',
      'modified_date',
      'created_date',
    ],
  },
  [CriteriaDimension.PAGINATION]: {
    pageNumber: 1,
    pageSize: TABLE_PAGE_SIZE,
    totalCount: 0,
  },
  [CriteriaDimension.FILTERS]: {
    account: '',
    createdBy: '',
    exchange_deal_id: '',
    phrase: '',
    status: '',
  },
};
